import { adTechLog } from '../../general/log';
import { updateAdSlot } from "../../general/ad-slot-storage";
/**
 * Destroy the slots specified if they have not already been destroyed.
 * @param {Array} slots An array of formatted slots, use window.adTech.getAdSlots( 'googletag' ).
 */
export const googletagDestroySlots = ( slots = [] ) => {

	if ( ! slots.length ) {
		// Destroying all ad slots.
		slots = window.adTech.getAdSlots( 'googletag' );
	}

	let slotsToDestroyGoogleTag = [],
		slotsToDestroy = []

	for ( const slot of slots ) {
		if ( ! slot.destroyed ) {
			// Gather the googletag slots.
			slotsToDestroyGoogleTag.push( slot.slot );
			slotsToDestroy.push( slot.id );

			// Update the ad slot as destroyed.
			slot.destroyed = true;
			slot.status_step_1_defined = false;
			slot.status_step_2_request = false;
			slot.status_step_3_received = false;
			slot.status_step_4_rendered = false;
			slot.status_step_5_loaded = false;
			slot.status_step_6_viewable = false;

			slot.slot = null;

			updateAdSlot( slot );
		}
	}

	adTechLog( {
		type: 'info',
		message: `Selected slots destroyed.`,
		details: {
			slots,
		}
	} )

	for ( const slot of slotsToDestroy ) {
		const element = document.getElementById( slot.id );

		if ( element ) {

			adTechLog( {
				type: 'event',
				message: `Event: "destroySlot", triggered for ${slot.id}`,
				details: {
					adSlotID: slot.id,
				},
			} );

			// Trigger the elements viewport status change.
			const destroySlotEvent = new CustomEvent( 'slotDestroyed', {
				detail: {
					adSlotID: slot.id,
				},
			} );

			element.dispatchEvent( destroySlotEvent );
		}
	}

	window.googletag.destroySlots( slotsToDestroyGoogleTag );
}
